/* eslint-disable no-console */
const getUserSignUpStatus = () => {
  // console.log('dealer-availability/email-signup-status.js, getUserSignUpStatus');
  const name = 'dealerNotificationSignup=';
  const cookieStr = decodeURIComponent(document.cookie);
  const arr = cookieStr.split(';');
  let value = '';
  arr.forEach((item) => {
    const isMatch = item.match(new RegExp(name, 'gi'));
    if (isMatch !== null) {
      value = item.substring(name.length + 1, item.length);
    }
  });
  return value === 'yes';
};

const setUserSignUpStatus = (status) => {
  // console.log('dealer-availability/email-signup-status.js, setUserSignUpStatus');
  const expiry = new Date();
  expiry.setFullYear(expiry.getFullYear() + 1);
  document.cookie = `dealerNotificationSignup=${status}; expires=${expiry.toUTCString()}; path=/`;
};

export {
  getUserSignUpStatus,
  setUserSignUpStatus,
};
/* eslint-enable no-console */
